import {
	USER_SET,
	USER_RESET_MESSAGE,
	USERS_FETCH_REQUEST,
	USERS_FETCH_FAILURE,
	USERS_FETCH_SUCCESS,
	USER_FETCH_REQUEST,
	USER_FETCH_FAILURE,
	USER_FETCH_SUCCESS,
	USER_LOGGED_IN_FETCH_REQUEST,
	USER_LOGGED_IN_FETCH_FAILURE,
	USER_LOGGED_IN_FETCH_SUCCESS,
	USER_UPDATE_REQUEST,
	USER_UPDATE_FAILURE,
	USER_UPDATE_SUCCESS,
	USER_CREATE_REQUEST,
	USER_CREATE_FAILURE,
	USER_CREATE_SUCCESS,
	USER_AVATAR_UPDATE_REQUEST,
	USER_AVATAR_UPDATE_FAILURE,
	USER_AVATAR_UPDATE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function users(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case USER_SET:
			return {
				...state,
				selected: payload.id,
			};

		case USER_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case USERS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case USERS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case USERS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case USER_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case USER_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case USER_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
				selected: Number(payload.user),
			};

		case USER_LOGGED_IN_FETCH_REQUEST:
			return state;

		case USER_LOGGED_IN_FETCH_FAILURE:
			return state;

		case USER_LOGGED_IN_FETCH_SUCCESS:
			return state;

		case USER_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case USER_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};
		case USER_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
				selected: Number(payload.user),
			};

		case USER_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case USER_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case USER_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case USER_AVATAR_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case USER_AVATAR_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};
		case USER_AVATAR_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
				selected: Number(payload.user),
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/users.js